import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { WebtieJsonSchema7 } from "../model/WebtieJsonSchema7";

dayjs.extend(utc);
dayjs.extend(timezone);

export class FormSchemaHelper {
  public static getReleaseDate = (formSchema: WebtieJsonSchema7): Date => {
    if (formSchema.releaseDate) {
      return dayjs(formSchema.releaseDate.dateTime).tz(formSchema.releaseDate.timeZone, true).toDate();
    }
    return dayjs().toDate();
  };

  public static getReleaseDateWithoutTimeZoning = (formSchema: WebtieJsonSchema7): Date => {
    if (formSchema.releaseDate) {
      return dayjs(formSchema.releaseDate.dateTime).toDate();
    }
    return dayjs().toDate();
  };

  public static isFormReleased = (formSchema: WebtieJsonSchema7): boolean => {
    if (!formSchema.releaseDate) {
      return true;
    }
    const releaseDate = FormSchemaHelper.getReleaseDate(formSchema);
    return dayjs(releaseDate).diff(dayjs()) <= 0;
  };
}
